import { SingleSelectFilterType } from '../../../ui/gzSingleSelectComplex/types';
import { GzSingleSelectComplexWebComponent } from '../../../ui/gzSingleSelectComplex';

export class GridFiltersHelper {
  public static ColumnKeyToSingleSelectFilterTypeMap = new Map<string, SingleSelectFilterType>([
    ['company', SingleSelectFilterType.COMPANY],
    ['policy', SingleSelectFilterType.POLICY],
  ]);

  public static getSingleSelectFilterTypeByColumnKey(key: string): SingleSelectFilterType {
    const filterType = GridFiltersHelper.ColumnKeyToSingleSelectFilterTypeMap.get(key);

    if (!filterType) {
      return SingleSelectFilterType.NONE;
    }

    return filterType;
  }

  public static populateFilterCallback($filterElement: GzSingleSelectComplexWebComponent, value) {
    const idValue = value.equals;
    $filterElement.value = idValue;
    const hasRequiredValueAlreadyLoaded = !!$filterElement.filterOptions.find(option => option.value === idValue);
    // We only want to reload the filter if there's an actual value we expect (instead of ''), or if the filter has no options
    const shouldReload = !!idValue || $filterElement.filterOptions.length === 0;

    if (!hasRequiredValueAlreadyLoaded && shouldReload) {
      $filterElement.setFilterOptions(undefined).then(() => {
        $filterElement.setFormValue(idValue);
      });
    }
  }
}
